export default __webpack_public_path__ + "static/media/screenShots_delivery-3.2122d01b.jpg";